import { TextAlignType } from '../../generated/types';

const DEFAULT_TRUNKSHOW_HEADER_MODULE = {
  name: 'Header',
  modelId: `SiteDisplay::Templates::Modules::TrunkshowHeaderModule:default:0`,
  id: 10000000,
  bgColor: 'White',
  platforms: ['desktop', 'mobile'],
  moduleType: 'SiteDisplay::Templates::Modules::TrunkshowHeaderModule',
  slides: [
    {
      id: '1',
      ctaUrl: null,
      mobileImage: null,
      featureImage: null,
      slideText: {
        ctaText: null,
        eyebrowText: null,
        editorialPosition: 'Center',
        editorialBgColor: 'Transparent',
        editorialEdgeMargin: 20,
        editorialWidth: 3,
        textColor: 'Black',
        verticalPadding: 10,
        horizontalPadding: 10,
        textAlign: TextAlignType.center,
        headlineText: { __typename: 'TextObject', body: '' },
        taglineText: { __typename: 'TextObject', body: '' }
      }
    }
  ]
};

export default DEFAULT_TRUNKSHOW_HEADER_MODULE;
